
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmCaptions 
} from '@vime/core';

import { define } from '../lib';
  

const CaptionsInputs: string[] = [
  'hidden',
  'isControlsActive',
  'isVideoView',
  'playbackStarted',
  'textTracks',
  'currentTextTrack',
  'isTextTrackVisible',
];

const CaptionsMethods: string[] = [
  
];

const CaptionsOutputs: string[] = [
  
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface Captions extends Components.VmCaptions {}

@ProxyCmp({
  inputs: CaptionsInputs,
  methods: CaptionsMethods,
})
@Component({
  selector: 'vm-captions',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: CaptionsInputs,
  outputs: CaptionsOutputs,
})
export class Captions {
  protected el: HTMLElement;

  

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-captions', VmCaptions);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, [])
  }
}
  